<template>
    <div v-if="user.api_key" class="api-token box">
        <div class="box-title">
            API Token
        </div>
        <div
            v-if="user"
            class="box-content"
        >
            <copy-handler
                v-slot:default="{
                    tooltipVisible,
                }"
                element=".copy-button"
                :value="user.api_key.key"
            >
                <div class="copy-button">
                    <button class="functional-button is-dark is-bold embed-button">
                        <i class="far fa-copy" />
                        <span>Copy</span>
                        <base-tooltip
                            :class="[{ active: tooltipVisible }]"
                        >
                            Copied!
                        </base-tooltip>
                    </button>
                </div>
            </copy-handler>
            <div class="token-box">
                <input
                    type="text"
                    :value="apiToken"
                    disabled
                >
            </div>
            <div class="controll-container flex">
                <base-submit-button
                    class="btn"
                    @click="showToken = ! showToken"
                >
                    Show Token
                </base-submit-button>
            </div><!-- .controll-container -->
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import CopyHandler from '@/components/CopyHandler';

export default {
    components: {
        CopyHandler,
    },

    data: () => ({
        showToken: false,
    }),

    computed: {
        ...mapState(['user']),

        /**
         *
         * @returns  {string}  API Token
         */
        apiToken() {
            return this.showToken
                ? this.user.api_key.key
                : '***********************************************';
        },
    },
};

</script>
